import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

export default function NotFound({ title, subtitle }) {
  return (
    <div
      style={{
        padding: "1rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <ErrorOutlineIcon
        style={{ marginRight: "1rem", height: 30, width: 30 }}
      />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="body1">{title}</Typography>
        <Typography variant="body2">{subtitle}</Typography>
      </div>
    </div>
  );
}

NotFound.defaultProps = {
  title: "Sua pesquisa não encontrou nenhum resultado correspondente.",
  subtitle:
    "Certifique-se que todos os valores dos filtros utilizados estejam escritos corretamente!",
};

NotFound.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
